var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_11262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.37061 5.80749L10.8041 8.24102L10.8157 8.11355C10.8157 6.83497 9.77666 5.7959 8.49808 5.7959L8.37061 5.80749Z",
    fill: "#CB90FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49801 4.25095C10.6302 4.25095 12.3608 5.98148 12.3608 8.11372C12.3608 8.61201 12.2604 9.08713 12.0865 9.52361L14.3462 11.7833C15.5128 10.8099 16.4321 9.55066 17 8.11372C15.6596 4.72223 12.3647 2.31958 8.49804 2.31958C7.41646 2.31958 6.38126 2.51271 5.41943 2.86035L7.08815 4.52519C7.52459 4.35524 7.99971 4.25095 8.49801 4.25095Z",
    fill: "#CB90FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.77254 2.14565L2.53396 3.90707L2.88548 4.25859C1.61077 5.25518 0.60259 6.58012 0 8.11361C1.33653 11.5051 4.63531 13.9077 8.49808 13.9077C9.69555 13.9077 10.8389 13.676 11.8857 13.2549L12.2141 13.5833L14.4661 15.8391L15.4511 14.858L1.75754 1.16064L0.77254 2.14565ZM5.04477 6.41401L6.23837 7.6076C6.2036 7.77371 6.18043 7.93979 6.18043 8.11361C6.18043 9.3922 7.2195 10.4313 8.49808 10.4313C8.6719 10.4313 8.83801 10.4081 9.00025 10.3733L10.1938 11.5669C9.68008 11.8219 9.10842 11.9764 8.49808 11.9764C6.36584 11.9764 4.63531 10.2459 4.63531 8.11361C4.63531 7.50331 4.78983 6.93161 5.04477 6.41401Z",
    fill: "#CB90FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_11262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/PasswordHide.48bdd5b848040ec719db9c3803a19447.svg";
export { ForwardRef as ReactComponent };